module.exports = __webpack_public_path__ + "img/servicio-planchado.54c0ea14.svg";